import request from '@/apis/request'
const resource = 'game-rooms' 

export default {   
  getRoomById: (uid) => { 
    return request.get(`${resource}/${uid}/st`)
  },

  postAddStake: (uuid,data) => { 
    return request.post(`${resource}/${uuid}/st`,data)
  },

  confirmStake: (uid,list_uuid,data) => { 
    return request.put(`${resource}/${uid}/st/${list_uuid}`,data)
  },

  cancelStake: (uid,list_uuid,data) => { 
    return request.delete(`${resource}/${uid}/st/${list_uuid}`,data)
  },

  
  getResult: (uid) => { 
    return request.get(`${resource}/${uid}/results`)
  },

  getResultHistory: (uid,params) => { 
    return request.get(`${resource}/${uid}/results/history`,{ params })
  },

  getResultSummary: (uid,params) => { 
    return request.get(`${resource}/${uid}/results/summary`,{ params })
  }, 

  postAddResult: (uuid,data) => { 
    return request.post(`${resource}/${uuid}/results`,data)
  },
}